import { Position } from '../types';

const OPPOSITE: Record<Position, Position> = {
  [Position.Top]: Position.Bottom,
  [Position.Bottom]: Position.Top,
  [Position.Left]: Position.Right,
  [Position.Right]: Position.Left,
};

/** The facing side; the connection line enters the pointer from the side opposite its start. */
export const oppositePosition = (position: Position): Position => OPPOSITE[position];
